<template>
 
  <div class="modal_user_content">

    <div class="content_profile">

      <div class="settings_description">

        <div class="row">
          <div class="label">
            {{ $t('profile_menu_edit_profile_delete_text') }}
          </div>
          <div class="field_text">
            <div class="btn red" @click="toggleModal">
              {{ $t('profile_menu_edit_profile_button_delete') }} 
            </div>
          </div>
        </div>

        <UiModal :is-auto-height="true" :has-close-button="false" v-if="isModalOpen">
          <slot name="modal-body">
            <div class="modal_content">
              <div class="modal_content-top">
                <i class="icon-setting"></i>
              </div>

              <div class="modal_content-body">
                <h3 class="is-heading">{{ t('profile_menu_edit_profile_delete_title') }}</h3>
                <span>{{ t('universal_delete_account_confirm') }}</span>
              </div>

              <div class="modal_content-controls">
                <UiButton
                    :name="$t('universal_button_cancel')"
                    :type="'grey'"
                    :locator="'forgot_password_view_button_restore_locator'"
                    @click="toggleModal"
                />
                <UiButton
                    :name="$t('universal_button_yes')"
                    :type="'red'"
                    :locator="'forgot_password_view_button_restore_locator'"
                    @click="handleRemoveAccount"
                    :is-loading="isLoading"
                />
              </div>
            </div>

          </slot>
        </UiModal>

      </div>

    </div>

  </div>
 

</template>

<script setup lang="ts">
 
import type { User } from '@/types/user'

const { t } = useI18n();
const {$api} = useNuxtApp()


interface Props {
  user: User,
  userId: number,
}

const props = defineProps<Props>();

const isLoading = ref(false);
const isModalOpen = ref(false);
const toggleModal = () => isModalOpen.value = !isModalOpen.value;

const handleRemoveAccount = function(){
  isLoading.value = true;

  $api.deleteProfileAccount(props.userId)
  .then((res) => {
    useToast().success('Account deleted');
    useAuth().logout();
  })
  .catch(function (error) {
    useToast().error(error.message || t('universal_generic_error'));
  })
  .finally(() => {
      isLoading.value = false;
      toggleModal()
  })

}


</script>


<style scoped>

.content_profile {
    
}

.modal_user_content .settings_description {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-start;
    vertical-align: middle;
    margin-right: auto;
    width: 100%;
    position: relative;
}

.modal_user_content .delete_profile_btn{
    box-shadow: 0px 0px 0px 1px #db2828 inset !important;
    color: #DB2828 !important;
    background: transparent none !important;
    font-weight: normal;

    float: right;
}

.modal_user_content .settings_description .row{
    display: flex;
    flex-direction: column;
    width: 100%;
}

.modal_user_content .settings_description .label{
    display: inline-block;
    min-width: 280px;
}

.modal_user_content .settings_description .field_text{
    display: flex;
    width: 100%;
    justify-content: flex-start;
}

.modal_user_content .settings_description .field_text .btn{

  margin-top: 1rem;
}

.modal_content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
  padding: 16px 8px;
}

.modal_content-top {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 9px;
  background-color: var(--new-un-general-color-light-red);
  border-radius: 50%;
}

.icon-setting {
  font-size: 20px;
  line-height: 20px;
  color: var(--new-un-general-color-red);
}

.modal_content-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  font-weight: 510;
  font-size: 14px;
  line-height: 17px;
}

.modal_content-body .is-heading {
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: var(--new-un-general-color-red);
}

.modal_content-controls {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

</style>
